import {
  r
} from "./chunk.4JTBA2KG.js";

// src/components/uploader/uploader.styles.ts
var uploader_styles_default = r` .uploader__file-input { position: absolute; visibility: hidden; } .uploader--dragging .uploader__drop-zone { border: 1px dashed var(--sl-color-primary-600); } .uploader__dropzone { text-align: center; border: 2px dashed var(--sl-color-gray-500); border-radius: var(--sl-border-radius-large); } .uploader__dropzone fadv-typography::part(base) { display: block; } .uploader__dropzone .uploader__drag-and-drop-label::part(base) { margin-top: var(--sl-spacing-3x-small); margin-bottom: var(--sl-spacing-2x-small); } .uploader__errors { position: absolute; top: 15%; left: 10%; right: 10%; pointer-events: none; white-space: pre-line; } .uploader__errors fadv-inline-alert::part(base) { margin-bottom: var(--sl-spacing-x-small); } `;

export {
  uploader_styles_default
};
